export default {
  inject: ['load'],
  data() {
    return {
      allDoctorConsultationTypesForOther: [],
      doctorConsultationType: null,
    };
  },
  methods: {
    getListOfDoctorConsultationTypesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllDoctorConsultationTypes').then(() => {
        if (this.$store.state.doctorConsultationTypeModule.successFlag) {
          this.allDoctorConsultationTypesForOther =
            this.$store.state.doctorConsultationTypeModule.allDoctorConsultationTypes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.doctorConsultationTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfDoctorConsultationTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDoctorConsultationTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDoctorConsultationType', id).then(() => {
        if (this.$store.state.doctorConsultationTypeModule.successFlag) {
          this.doctorConsultationType =
            this.$store.state.doctorConsultationTypeModule.doctorConsultationType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.doctorConsultationTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDoctorConsultationTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.doctorConsultationTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
